import React from "react";

// Helper function to safely format Firestore Timestamp or ISO strings
function formatDate(date) {
  try {
    const formatted = new Date(
      date?.seconds ? date.seconds * 1000 : date
    ).toLocaleDateString(undefined, {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    return formatted;
  } catch {
    return "Unknown Date";
  }
}

const BlogPostOverlay = ({ post, onClose }) => {
  if (!post) return null;

  // Filter out empty or invalid image URLs
  const validImages = Array.isArray(post.images)
    ? post.images.filter((url) => typeof url === "string" && url.trim() !== "")
    : [];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-start overflow-y-auto">
      <div className="bg-white p-4 rounded-lg max-w-3xl w-full m-4 relative">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 p-2 bg-gray-200 rounded-full hover:bg-gray-300"
        >
          ✕
        </button>

        <h1 className="text-3xl font-bold mb-2">{post.title}</h1>

        {post.imageUrl && (
          <img
            src={post.imageUrl}
            alt={post.title}
            className="w-full h-auto mb-4 rounded"
          />
        )}

        <p className="mb-2 text-gray-700">{post.shortDescription}</p>

        <div className="text-gray-600 text-sm mb-4">
          {formatDate(post.publishDate)} | Read time: {post.estimatedTimeToRead}
        </div>

        <div className="text-gray-800 whitespace-pre-line mb-6">{post.post}</div>

        {validImages.length > 0 && (
          <div>
            <h2 className="text-lg font-semibold mb-2 text-gray-800">More</h2>
            <div className="flex flex-col gap-4">
              {validImages.map((url, index) => (
                <img
                  key={index}
                  src={url}
                  alt={`Additional image ${index + 1}`}
                  className="w-full h-auto rounded"
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogPostOverlay;
